import React from 'react';

export default function ItemAnalise({ analise }) {
  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getOrigemInfo = () => {
    if (analise.tipo_usuario_origem === 1) {
      return { icon: 'fas fa-mobile-alt', text: 'App', class: 'origem-app' };
    }
    if (analise.tipo_usuario_origem === 2) {
      return { icon: 'fab fa-whatsapp', text: 'WhatsApp', class: 'origem-whatsapp' };
    }
    return { icon: 'fas fa-question', text: 'N/A', class: 'origem-unknown' };
  };

  const getStatusClass = () => {
    const statusId = analise.analisedemanda_status_id;
    switch (statusId) {
      case 1: return 'status-pendente';
      case 2: return 'status-devolvida';
      case 3: return 'status-transferida';
      case 4: return 'status-finalizada';
      default: return 'status-pendente';
    }
  };

  const origem = getOrigemInfo();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
      {/* Coluna da esquerda - Informações principais */}
      <div style={{ flex: 2 }}>
        <div className="obra-header">
          <div>
            <h3 className="obra-title">{analise.demanda_categoria_descricao || 'Categoria não informada'}</h3>
            <span className={`obra-status ${getStatusClass()}`}>
              {analise.analisedemanda_status_descricao || 'Pendente'}
            </span>
          </div>
        </div>

        <div className="obra-info" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="obra-info-item">
            <strong>Demanda:</strong> #{analise.demanda_id}
          </div>
          <div className="obra-info-item">
            <strong>Análise:</strong> #{analise.analisedemanda_id}
          </div>
          <div className="obra-info-item">
            <strong>Funcionário:</strong> {analise.analisedemanda_funcionario_envolvido_nome || 'Não identificado'}
          </div>
          <div className="obra-info-item">
            <strong>Setor:</strong> {analise.analisedemanda_setor_descricao || 'Não informado'}
          </div>
          <div className="obra-info-item">
            <strong>Data Análise:</strong> {formatarData(analise.analisedemanda_criado_em)}
          </div>
          <div className="obra-info-item">
            <strong>Prioridade:</strong> {analise.demanda_prioridade || 'Normal'}
          </div>
          <div className="obra-info-item" style={{ gridColumn: '1 / -1' }}>
            <strong>Solicitante:</strong> {analise.demanda_usuario_nome || 'Não identificado'}
          </div>
        </div>
        
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
          <strong>Descrição:</strong> {analise.demanda_descricao || 'Sem descrição disponível'}
        </div>
      </div>
      
      {/* Coluna do meio - Origem e Status */}
      <div style={{ flex: 1 }}>
        <div style={{ 
          marginBottom: '15px', 
          padding: '8px 12px', 
          backgroundColor: origem.class === 'origem-app' ? '#e8f5e8' : '#e8f8f5', 
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <i className={origem.icon} style={{ color: origem.class === 'origem-app' ? '#2e7d32' : '#16a085' }}></i>
          <span style={{ fontSize: '14px', fontWeight: 'bold', color: origem.class === 'origem-app' ? '#2e7d32' : '#16a085' }}>
            Origem: {origem.text}
          </span>
        </div>
        
        {analise.analisedemanda_transferido_para_setor_descricao && (
          <div style={{ 
            marginBottom: '10px',
            padding: '8px 12px', 
            backgroundColor: '#fff3cd', 
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <i className="fas fa-exchange-alt" style={{ color: '#856404' }}></i>
            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#856404' }}>
              Transferida para: {analise.analisedemanda_transferido_para_setor_descricao}
            </span>
          </div>
        )}
        
        {analise.analisedemanda_descricao_retorno && (
          <div style={{ 
            padding: '8px 12px', 
            backgroundColor: '#f8d7da', 
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <i className="fas fa-undo" style={{ color: '#721c24' }}></i>
            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#721c24' }}>
              Devolvida
            </span>
          </div>
        )}
      </div>
      
      {/* Coluna da direita - Ações */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' }}>
        <div className="obra-actions" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button className="button btn-demanda-primary" style={{ width: '100%' }}>
            <i className="fas fa-eye"></i>
            Ver Detalhes
          </button>
        </div>
      </div>
    </div>
  );
}